import React from 'react'

import { Route, Routes } from 'react-router-dom'

//Layouts
import NonAuthLayout from '../Layouts/NonAuthLayout'
import VerticalLayout from '../Layouts/index'
import { AuthProtected } from './AuthProtected'
//routes
import { authProtectedRoutes, publicRoutes, smartProtectedRoutes } from './allRoutes'
import SmartProtectedRoute from './SmartProtectedRoute'

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {smartProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <SmartProtectedRoute>
                  {route.component}
                </SmartProtectedRoute>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <VerticalLayout>{route.component}</VerticalLayout>
                </AuthProtected>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  )
}

export default Index
